/*
 * @Descripttion:
 * @version:
 * @Author: sxy
 * @Date: 2021-09-29 16:59:09
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-03-29 17:28:02
 * Copyright (c) 2017-2021 duobaoyu, Inc. All rights reserved.
 * Unless required by applicable law or agreed to in writing,
 * Unauthorized use and distribution by any person or organization is prohibited.
 */
/*
 * 定义扩展的env环境
 */
import _ from 'lodash';
import config from '../../config/config.final.json';

const API_ADDRESS = config.API_ADDRESS;
const API_OLD_ADDRESS = config.API_OLD_ADDRESS;

export default {
  newBiz: `${API_ADDRESS}/transbiz`,
  api: API_ADDRESS,
  activitybiz: `${API_ADDRESS}/activitybiz`,
  transbiz: `${API_ADDRESS}/transbiz`,
  transbiz2c: `${API_ADDRESS}/transbiz_2c`,
  transbiz_2c: `${API_ADDRESS}/transbiz_2c`,
  transbiz2c_new: `${API_ADDRESS}/customergateway/schemecenter/outer`,
  transbiz_2c_new: `${API_ADDRESS}/customergateway/schemecenter/outer`,
  transbiz_new: `${API_ADDRESS}/managergateway/schemecenter/outer`,
  transbiz_test2: `${API_ADDRESS}/transbiz`,
  chatsystemnew: `${API_ADDRESS}/chatsystemnew`,
  ordercore2b: `${API_ADDRESS}/managergateway/ordercore`,
  ordercore2c: `${API_ADDRESS}/customergateway/ordercore`,
  insurancecenter2c: `${API_ADDRESS}/customergateway/insurancecenter`,
  insurancecenter2b: `${API_ADDRESS}/managergateway/insurancecenter`,
  paymentCenter: `${API_ADDRESS}/payment-center`,
  paymentcenter: `${API_ADDRESS}/managergateway/paymentcenter`,
  healtycenter: `${API_ADDRESS}/customergateway/healtycenter/outer/`,
  customergateway: `${API_ADDRESS}/customergateway`,
  channelcenter: `${API_ADDRESS}/customergateway/channelcenter`,
  productcenter: `${API_ADDRESS}/customergateway/productcenter`,
  schemecenter: `${API_ADDRESS}/customergateway/schemecenter`,
  schemecenter2b: `${API_ADDRESS}/managergateway/schemecenter`,
  managergateway: `${API_ADDRESS}/managergateway/customercenter`,
  customercenter: `${API_ADDRESS}/managergateway/customercenter`,
  customercenter2c: `${API_ADDRESS}/customergateway/customercenter`,
  commoditycenter: `${API_ADDRESS}/customergateway/commoditycenter/v1/outer`,
  scorecenter: `${API_ADDRESS}/customergateway/scorecenter/v1/outer`,
  usercenter: `${API_ADDRESS}/customergateway/usercenter/v1/outer`,
  usercenter1: `${API_ADDRESS}/customergateway/usercenter`,
  usercenter2: `${API_ADDRESS}/managergateway/usercenter/v2`,
  usercenter2c: `${API_ADDRESS}/customergateway/usercenter/v2`,
  filecenter: `${API_ADDRESS}/customergateway/filecenter`,
  contentcenter: `${API_ADDRESS}/managergateway/contentcenter`,
  employeecenter: `${API_ADDRESS}/managergateway/employeecenter`,
  employeecenterToC: `${API_ADDRESS}/customergateway/employeecenter`,
  qualitycenter: `${API_ADDRESS}/managergateway/qualitycenter`,
  productcenterToB: `${API_ADDRESS}/managergateway/productcenter`,
  systembiz: `${API_ADDRESS}/systembiz`,
  report: `${API_ADDRESS}/report`,
  sembiz: `${API_OLD_ADDRESS}/sembiz`,
  systemcenter: `${API_ADDRESS}/managergateway/system-center`,
  dev_paycenter: 'http://dby-h5.alpha.tdev.cn',
  lichenbiz: `${API_ADDRESS}/managergateway/lichenbiz`,
  schemecore: `${API_ADDRESS}/managergateway/schemecore`,
  customergatewaySchem: `${API_ADDRESS}/customergateway/schemecore`,
  douyinmidserve: `${API_ADDRESS}/douyin-midserve`,
  weixinmidserve: `${API_ADDRESS}/customergateway/weixinmidserve`,
  weixinmidserve_new: `${API_ADDRESS}/managergateway/weixinmidserve`,
  openapibridge: `${API_ADDRESS}/managergateway/openapibridge`,
  customercore: `${API_ADDRESS}/managergateway/customercore`,
  customercore2c: `${API_ADDRESS}/customergateway/customercore`,
  blueWhale_managergateway: `${API_ADDRESS}/managergateway/usercenter`,
  blueWhale_customercore: `${API_ADDRESS}/managergateway/customercore`,
  productcenter_managergateway: `${API_ADDRESS}/managergateway/productcenter`,
  ordercenter: `${API_ADDRESS}/customergateway/ordercenter`,
  ordercenterToB: `${API_ADDRESS}/managergateway/ordercenter`,
  blueWhale_labelbussine: `${API_ADDRESS}/managergateway/labelbussine`,
  tmkcore: `${API_ADDRESS}/managergateway/tmkcore`,
  worksheet: `${API_ADDRESS}/managergateway/tmkcore/outer/worksheet/v1`,
  dispatchcenter: `${API_ADDRESS}/managergateway/dispatchcenter`,
  littlefish_2c: `${API_ADDRESS}/littlefish_2c/agreementSign`,
  datacenter: `${API_ADDRESS}/managergateway/datacenter`,

  getWs() {
    return `wss://wss${this.environment}.91duobaoyu.com/ws`;
  },
  getWxAuthPath(name, params = [], opt) {
    for (let i = params.length - 1; i >= 0; i--) {
      if (!params[i] && params[i] !== 0 && params[i] !== false) {
        params.splice(i, 1);
      } else {
        break;
      }
    }
    if (_APP_.ENV_ALIAS == 'dby' && (!opt || !opt.isOld)) {
      return `${_APP_.WXAUTH_ADDRESS}/dby${_.upperFirst(name)}${_.upperFirst(
        _APP_.ENV
      )}${[''].concat(params || []).join('-')}`;
    }
    return (
      `${_APP_.WXAUTH_ADDRESS}/${name}${
        _.upperFirst(_APP_.ENV)
      }${[''].concat(params || []).join('-')}`
    );
  },
  // 初步过渡方案，强制使用新的生产环境的H5授权中心
  getWxAuthPath2(name, params, opt) {
    for (let i = params.length - 1; i >= 0; i--) {
      if (!params[i] && params[i] !== 0 && params[i] !== false) {
        params.splice(i, 1);
      } else {
        break;
      }
    }
    if (_APP_.ENV_ALIAS == 'dby' && (!opt || !opt.isOld)) {
      return `${_APP_.OTHER.WXAUTH_FINAL_ADDRESS}/dby${_.upperFirst(
        name
      )}${_.upperFirst(_APP_.ENV)}${[''].concat(params || []).join('-')}`;
    }
    return `${_APP_.OTHER.WXAUTH_FINAL_ADDRESS}/${name}${_.upperFirst(
      _APP_.ENV
    )}${[''].concat(params || []).join('-')}`;
  },
  // 第二步过渡方案
  getWxAuthPath1(name, params, opt) {
    for (let i = params.length - 1; i >= 0; i--) {
      if (!params[i] && params[i] !== 0 && params[i] !== false) {
        params.splice(i, 1);
      } else {
        break;
      }
    }
    if (_APP_.ENV_ALIAS == 'dby' && (!opt || !opt.isOld)) {
      return `${_APP_.OTHER.WXAUTH_ADDRESS}/dby${_.upperFirst(
        name
      )}${_.upperFirst(_APP_.ENV)}${[''].concat(params || []).join('-')}`;
    }
    return `${_APP_.OTHER.WXAUTH_ADDRESS}/${name}${_.upperFirst(_APP_.ENV)}${[
      ''
    ]
      .concat(params || [])
      .join('-')}`;
  }
};
